import Row from '@ilg-totallymoney/ui/components/Row'

import SameDayDepositBadge from '@components/SameDayDepositBadge'

const UnscoredTableItemBadgesSection = ({
    hasSameDayDepositBadge,
}: {
    hasSameDayDepositBadge: boolean
}) => (
    <Row flexWrap="wrap" space="space10" mb="space20">
        {hasSameDayDepositBadge ? <SameDayDepositBadge /> : null}
    </Row>
)

export default UnscoredTableItemBadgesSection
